module.exports = __webpack_public_path__ + "static/media/emotions-why-core.f69572d9.png";